/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloseReasonDto
 */
export interface CloseReasonDto {
    /**
     * 
     * @type {string}
     * @memberof CloseReasonDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof CloseReasonDto
     */
    subCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof CloseReasonDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CloseReasonDto
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the CloseReasonDto interface.
 */
export function instanceOfCloseReasonDto(value: object): value is CloseReasonDto {
    return true;
}

export function CloseReasonDtoFromJSON(json: any): CloseReasonDto {
    return CloseReasonDtoFromJSONTyped(json, false);
}

export function CloseReasonDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloseReasonDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'subCategory': json['subCategory'] == null ? undefined : json['subCategory'],
        'description': json['description'] == null ? undefined : json['description'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
    };
}

export function CloseReasonDtoToJSON(json: any): CloseReasonDto {
    return CloseReasonDtoToJSONTyped(json, false);
}

export function CloseReasonDtoToJSONTyped(value?: CloseReasonDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'subCategory': value['subCategory'],
        'description': value['description'],
        'tenantId': value['tenantId'],
    };
}

